



























































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { Respondent, Response, Question } from '@/store/modules/survey-store-module'
import { Checkbox, Icon } from '@alpha/ink'
import AnswerToggle from './AnswerToggle.vue'
import CollapsibleSection from '@/components/Survey/CollapsibleSection.vue'
import CollapseArrow from '@/components/Survey/ResponseManagement/CollapseArrow.vue'
import store from '@/store'
import loadingGif from '@/assets/img/loading.gif'
import { getOpenEnd, isOpenEnd } from '@/components/Survey/Utilities/SurveyUtilities'

@Component({
  components: {
    Checkbox,
    Icon,
    AnswerToggle,
    CollapsibleSection,
    CollapseArrow
  }
})
export default class ResponsesByRespondent extends Vue {
  @Prop({ required: true }) respondent!: Respondent
  @Prop({ required: true }) readonly respondentSelected!: boolean
  @Prop({ required: true }) readonly responseRemovalMap!: Record<string, boolean>
  @Prop({ required: false, default: false }) readonly setExpanded!: boolean
  loadingGif = loadingGif
  expanded: boolean = false
  render: boolean = false

  mounted () {
    setTimeout(() => {
      this.render = true
    }, 0)
  }

  @Watch('setExpanded', { immediate: true })
  toggleExpanded (val: boolean, oldVal: boolean) {
    setTimeout(() => {
      this.expanded = val
    }, 0)
  }

  get responses () {
    return this.respondent.responses!.reduce((acc: Array<Response & { answer: any, question?: Question }>, response) => {
      const question = store.getters.survey.questionById(response.questionId)
      if (isOpenEnd(question!)) {
        const answer = getOpenEnd(response, question!)
        if (!answer) return acc
        acc.push({
          ...response,
          question,
          answer
        })
      }
      return acc
    }, []).sort((a, b) => (a.question?.displayOrder! < b.question?.displayOrder!) ? -1 : 1)
  }

  get visibleResponses () {
    return this.responses.filter(response => {
      return this.responseShown(response.id)
    })
  }

  get responseHeader () {
    if (!this.respondentSelected) return 'Participant hidden'
    return `${this.visibleResponses.length} of ${this.responses.length} Open Ends`
  }

  get isAlphaAdmin () {
    return store.state.user.authenticatedUser!.admin
  }

  responseShown (responseId: string) {
    return this.responseRemovalMap[responseId]
  }

  toggleResponseRemoval (payload: {response: Response}) {
    this.$emit('toggleResponseRemoval', payload)
  }

  toggleRespondentRemoval ($event: MouseEvent) {
    const shiftClick = $event.shiftKey
    const selection = document.getSelection()
    if (selection) selection.removeAllRanges()
    const payload = {
      respondent: this.respondent,
      shiftClick
    }
    this.$emit('toggleRespondentRemoval', payload)
  }
}
